<template>
  <div class="nav-container">
    <div class="link link-left">
      <div v-if="back" @click="goBack()">
        <img :src="backIcon" class="icon float-left" />
        <div class="float-left link-text">{{ $t('NAVIGATION.GO_BACK') }}</div>
      </div>
    </div>
    <div class="link link-right">
      <router-link v-if="right" :to="{name: right.route, params: right.params}">
        <img :src="forwardIcon" class="icon float-right" />
        <div class="float-right link-text">{{right.text}}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getImage } from '@/services/StyleService';

export default {
  name: 'nav-bar',
  props: {
    back: Boolean,
    right: {
      text: String,
      route: String,
      params: Object
    }
  },
  computed: {
    backIcon() {
      return getImage('./chevron-left.svg');
    },
    forwardIcon() {
      return getImage('./chevron-right.svg');
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },

    goToRoute(route, params) {
      this.$router.replace({
        name: route,
        params
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-container {
  display: flex;
}
.link {
  &:hover {
    opacity: 0.8;
  }
}
.link-left,
.link-right {
  width: 50%;
  cursor: pointer;
}
.link-right {
  text-align: right;
}
.link-text {
  line-height: 24px;
  color: #3f536e;
  font-weight: 700;
}
.icon {
  height: 25px;
}
</style>
